import { NgModule } from '@angular/core';

import { CustomFieldModalComponent } from './custom-field-modal.component';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { InlineErrorModule } from 'components/errors/inline-error.module';
import { CheckboxModule } from '@certemy/ui-components';
import { MessageBlockModule } from 'components/message-block/message-block.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TemplateCustomFieldsService } from '../template/services/template-custom-fields.service';

import { CustomFieldValueModule } from '../custom-field-value/custom-field-value.module';
import { NgbCustomModalModule } from 'components/modal-windows/ngb-custom-modal/ngb-custom-modal.module';

@NgModule({
  imports: [
    CertemyCommonModule,
    InlineErrorModule,
    NgbTooltipModule,
    CheckboxModule,
    CustomFieldValueModule,
    NgbCustomModalModule,
    MessageBlockModule,
  ],
  declarations: [CustomFieldModalComponent],
  providers: [TemplateCustomFieldsService],
  exports: [CustomFieldModalComponent],
})
export class CustomFieldModalModule {}
